/* eslint-disable no-undef */
import {makeStyles, Tooltip} from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Badge from '@material-ui/core/Badge';
import Box from '@material-ui/core/Box';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import Switch from '@material-ui/core/Switch';
import Typography from '@material-ui/core/Typography';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';
import ClearAllIcon from '@material-ui/icons/ClearAll';
import {DataLayer} from '@nimbus-target/ui';
import IconButton from 'components/buttons/IconButton';
import {useUserContext} from 'context';
import {Fragment} from 'react';

function gtag(...rest) {
	DataLayer.push(...rest.slice(1));
}

const useStyles = makeStyles(theme => ({
	title: {
		fontSize: '0.875rem',
		fontWeight: 600,
		color: theme.palette.type === 'dark' ? theme.palette.text : theme.palette.nimbus.neutral.normal,
	},
	switchRoot: {},
	switchBase: {},
	switchThumb: {},
	switchTrack: {},
	switchChecked: {},
	switchLabel: {
		fontSize: '0.875rem',
		fontWeight: 400,
		marginBottom: 2,
	},
	appBar: {
		position: 'static',
		backgroundColor: theme.palette.type === 'dark' ? '#333333' : '#ffffff',
		borderTop: '1px solid rgba(196, 196, 196, 0.5)',
		boxShadow: theme.palette.type === 'dark' ? undefined : 'none',
	},
	appBarText: {
		fontFamily: 'Roboto, sans-serif',
		fontWeight: 500,
		textTransform: 'capitalize',
	},
}));

export const AlertsHeader = ({
	nimbusLength = 0,
	isSwitchChecked = false,
	setSwitchChecked,
	setDrawerNotifications,
	clearAllNotifications = () => {},
}) => {
	const styles = useStyles();
	const {canClearAllNotifications} = useUserContext();

	return (
		<Fragment>
			<Box display='flex' alignItems='center' justifyContent='space-between' px={2} py={0.5}>
				<Typography variant='button' className={styles.title}>
					NOTIFICAÇÕES
				</Typography>
				<Box display='flex' alignItems='center' justifyContent='center'>
					<FormGroup row={true}>
						<FormControlLabel
							classes={{label: styles.switchLabel}}
							label={!isSwitchChecked ? 'Mostrar lidas' : 'Mostrar não lidas'}
							labelPlacement={'start'}
							control={
								<Switch
									classes={{
										root: styles.switchRoot,
										switchBase: styles.switchBase,
										thumb: styles.switchThumb,
										track: styles.switchTrack,
										checked: styles.switchChecked,
									}}
									color='primary'
									disableRipple={false}
									onChange={evt => {
										setSwitchChecked(evt.target.checked);
										gtag('event', 'header_alerts_switch_read', {
											checked: evt.target.checked,
										});
									}}
									checked={isSwitchChecked}
								/>
							}
						/>
					</FormGroup>

					{canClearAllNotifications && (
						<IconButton handleClick={() => clearAllNotifications()}>
							<Tooltip title={'Limpar todas as notificações'} style={{alignContent: 'center'}}>
								<ClearAllIcon />
							</Tooltip>
						</IconButton>
					)}
					<IconButton handleClick={() => setDrawerNotifications(false)}>
						<CancelOutlinedIcon />
					</IconButton>
				</Box>
			</Box>
			<AppBar square={true} color='default' className={styles.appBar}>
				<Box display='flex' justifyContent='center' alignItems='center' py={1}>
					<Badge variant='dot' color='error' overlap='rectangular' invisible={!nimbusLength}>
						<Typography className={styles.appBarText}>Sellera</Typography>
					</Badge>
				</Box>
			</AppBar>
		</Fragment>
	);
};

AlertsHeader.displayName = 'Alerts.Header';
export default AlertsHeader;
